export default __webpack_public_path__ + "static/helix-ps-3-f99fa4533c7adc08ea4baf405b582191.jpg";